(() => {
  'use strict';

  const mobile = window.matchMedia('(max-width: 989px)');
  let banner = null;
  let anchor = null;

  const updatePosition = () => {
    const slot = document.querySelector('[data-tajima-mobile-after-menu-slot]');
    if (!slot) return;

    if (!anchor || !anchor.isConnected) {
      if (banner && banner.parentNode === slot) banner.remove();
      banner = document.querySelector('#tajima-sidebar-panel .tajima-sidebar__banners--after-menus');
      if (banner) {
        anchor = document.createComment('after-menu-banners-original-position');
        banner.parentNode.insertBefore(anchor, banner);
      } else {
        anchor = null;
      }
    }

    if (mobile.matches && banner) {
      if (banner.parentNode !== slot) slot.appendChild(banner);
      const visibleCount = banner.querySelectorAll(
        '.tajima-sidebar__banner-item:not(.tajima-sidebar__banner-item--pc)'
      ).length;
      const list = banner.querySelector('.tajima-sidebar__banner-list');
      if (list) list.classList.toggle('is-single-mobile-banner', visibleCount === 1);
      slot.classList.toggle('is-visible', visibleCount > 0);
      slot.hidden = visibleCount === 0;
    } else {
      if (banner && anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(banner, anchor.nextSibling);
      }
      slot.classList.remove('is-visible');
      slot.hidden = true;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updatePosition, { once: true });
  } else {
    updatePosition();
  }

  if (mobile.addEventListener) {
    mobile.addEventListener('change', updatePosition);
  } else {
    mobile.addListener(updatePosition);
  }

  document.addEventListener('shopify:section:load', () => {
    window.requestAnimationFrame(updatePosition);
  });
})();
